export default "__VITE_ASSET__CjEmlvq3__"